import type { FormEvent } from 'react'
import { useState } from 'react'
import { MaruyaApiError } from '../../lib/maruya-api'
import { createDeleteRequest } from '../../lib/rag-api'

export type DeleteRequestDocument = {
  document_id: string
  title: string
}

type DeleteRequestDialogProps = {
  document: DeleteRequestDocument
  onClose: () => void
  onSuccess: () => void | Promise<void>
}

export function DeleteRequestDialog({
  document,
  onClose,
  onSuccess,
}: DeleteRequestDialogProps) {
  const [reason, setReason] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleSubmit(event: FormEvent) {
    event.preventDefault()
    setSubmitting(true)
    setError(null)

    try {
      await createDeleteRequest(document.document_id, reason.trim())
      await onSuccess()
    } catch (err) {
      if (err instanceof MaruyaApiError) {
        if (err.body.error === 'pending_request_exists') {
          setError('このナレッジは既に申請中です')
        } else if (err.body.error === 'reason_required') {
          setError('理由を入力してください')
        } else {
          setError(err.body.message ?? err.message)
        }
      } else {
        setError('削除申請に失敗しました')
      }
    } finally {
      setSubmitting(false)
    }
  }

  return (
    <div className="dialog-backdrop" onClick={onClose}>
      <div
        className="dialog card"
        role="dialog"
        aria-modal="true"
        aria-labelledby="delete-request-title"
        onClick={(event) => event.stopPropagation()}
      >
        <header className="dialog-header">
          <h2 id="delete-request-title">削除申請</h2>
          <p className="lede">
            <strong>{document.title}</strong>
          </p>
        </header>

        <form className="form-card" onSubmit={(event) => void handleSubmit(event)}>
          <label className="field">
            <span>削除理由</span>
            <textarea
              required
              rows={4}
              value={reason}
              onChange={(event) => setReason(event.target.value)}
              placeholder="例: 内容が古く、現在の運用と一致しないため"
            />
          </label>

          {error && <p className="form-error">{error}</p>}

          <div className="actions-row">
            <button type="submit" className="btn btn-primary" disabled={submitting}>
              {submitting ? '送信中…' : '申請する'}
            </button>
            <button
              type="button"
              className="btn btn-ghost"
              disabled={submitting}
              onClick={onClose}
            >
              キャンセル
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
